module.exports = __webpack_public_path__ + "static/media/icon-download-file.8ec2236c.svg";